import { CancelablePromise, OpenAPI, request as __request } from '/src/api';
import type { TGetAssetsPaymentsReportRequest, TGetAssetsPaymentsReportResponse } from '/src/lib/types';

export class AssetsPaymentsService {
  /**
   * Formats/calculates Assets & Payments response data
   */
  private static _interceptor = (balances: any) => {
    const newBalances: any[] = [];

    for (const chartItem of balances.sunburstChart.children) {
      if (chartItem.amount !== 0) {
        newBalances.push({
          amount: chartItem.amount,
          company: chartItem.name ? chartItem.name : '',
          chartTitle: 'balances',
        });
      }
    }

    return newBalances;
  };

  /**
   * Get Loan Balances report
   */
  public static async get(req: TGetAssetsPaymentsReportRequest): CancelablePromise<TGetAssetsPaymentsReportResponse> {
    return this._interceptor(
      await __request(OpenAPI, {
        method: 'GET',
        url: '/reports/balances',
        query: req,
      })
    );
  }
}
